import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import FalkenHome from "@/views/falken/HomeView.vue";
import FalkenTryeRange from "@/views/falken/FalkenTryeRange.vue";
import NewsRoom from "@/views/falken/NewsRoom.vue";
import NewsRoomDetails from "@/views/falken/NewsRoomDetails.vue";
import PageNotFound from "@/views/falken/PageNotFoundView.vue";
import FindAStockist from "@/views/falken/FindAStockist.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "falken-home",
    component: FalkenHome,
  },
  {
    path: "/tyre-range",
    name: "tyre-range",
    component: FalkenTryeRange,
  },
  {
    path: "/news-room",
    name: "news-room",
    component: NewsRoom,
  },
  {
    path: "/news-room-details",
    name: "news-room-details",
    component: NewsRoomDetails,
  },
  {
    path: "/find-a-stockist",
    name: "find-a-stockist",
    component: FindAStockist,
  },
  {
    path: '/404',
    name: 'page-not-found',
    component: PageNotFound
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: "/404"
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash }
    }

    if (from && Object.keys(to.query).length) {
      if (to.fullPath.split('?')[0] == from.fullPath.split('?')[0]) return;
    }

    return { top: 0, behavior: 'smooth' }; 
  }
});

router.afterEach(() => {
  const reCapthca = document.querySelector('.grecaptcha-badge') as any;
  if(router.currentRoute.value.name && (router.currentRoute.value.name !== 'falken-home')) {
    if(reCapthca) {
      reCapthca.style.visibility = 'hidden';
    }
  } else {
    if(reCapthca) {
      reCapthca.style.visibility = `visible`;
    }
  }
});

export default router;
